import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { updateEditAction, writeAction } from '@/main/store/actionsFunctions';
import { apiProvider as zakazkaApiProvider } from '@/modules/servis/zakazka/api';
import hash from 'object-hash';
import { convertToObjects } from '@/main/utils/table';
import { UPDATE, UPDATE_BASIC_TABLE_SCHEMA_DATA, END_LOADING, START_LOADING } from '@/main/store/listEditTypes';

import { Status } from '@/main/store/@types/page';
import { router } from '@/main/router';


import {
	DEPENDENT_TABLES,
	NAME as name,
	CRUMB_LABEL_KEY,
	ZAKAZKA_TYP,
	ND,
	PRACOVNI_POZICE,
	MERGE_ZAKAZNIK,
	MERGE_VOZIDLO,
	ZAKAZKY_LIST,
	ZAKAZKY_ESHOP_LIST,
	POLOZKY,
	ZAKAZKA_ND_PENDING,
	ZAKAZKA_PP_PENDING,
	SERVICE_PKG_LABOR,
	SERVICE_PKG_PARTS,
	CAMPAIGN_DETAILS,
	ORDER_STATUS,
	PLANNED_ORDER_SERVICE_JOB,
} from '../constants';
import { apiProvider } from '../api';
import { editMutations, actions, types } from './types';
import { ZAKAZKA_DRUH } from '../../zakazka/constants';

type VuexProps = { commit: any, dispatch: any, state:any };
type Data<T = {}> = { data: any & T };
export const dropdownList = {
	ZakazkaDruh: [],
	OzakazkaPzn: [],
	ZakaznikSk: [],
	Lakdruh: [],
	ProvozovnaId: [],
	SmluvpartnerPzn: [],
	FakturaceprofilId: [],
	VariaList: [],
	SafetyRemarks: [],
	OrderSubType: [],
	CancellationReasons: [],
	LabourList: [],
	TimeUnit: [],
	TotalTimeUnit: [],
	TechiciansList: [],
	VyrobekndOzn: [],
	PartsLists: [],
	AllPartsLists: [],
	StrednaklOzn: [],
	ServiceJobs: [] as any[],
	OrderReportTypes: [] as any[],
	ServiceJobForItems: [] as any[],
	Mrp: [],
	AllMrp: [],
	AllDnp: [],
	Stock: [],
	MeasuringUnit:[],
	Parts: [] as any[],
	DefaultPartsList: [] as any[],
	InitialPartsLoadList: [] as any[],
};

export const localState = {
	vybavaSelectValue: '',
	kurzy: null as any,
	meny: null,
	VozidloId: null as string | null,
	lastStavKm: null as number | null,
	rpzvSent: false,
	showInfoSideBar: true,
};

export const edit = {
	VozidloZakaznikId: null as number | null, // TP1-TODO: prejmenovat podle BE az bude
	OtevreneZak: null as number | null, // TP1-TODO: prejmenovat podle BE az bude
	EZakazky: null as number | null, // TP1-TODO: prejmenovat podle BE az bude
	OzakazkaState: null as string | null, // TP1-TODO: status zakazky zaplanovana/ v priprave
	VozidloIdSpz: null as string | null,
	CancelOrRescheduleStatus: null as string | null,
	LakdruhIdText: null as string | null, // TP!-TODO: podivat se proc nechodi z BE
	LakdruhOzn: null as number | null, // TP1-1-TODO: nema to byt lakDruhId?? overit
	Oznam: null as string | null,
	Memo: null as string | null,
	VstupDat: null as string | null,
	EditDat: null as string | null,
	FakturaceprofilId: null as number | null,
	Mobilita: null as string | null,
	MobilitaPrp: null as boolean | null,
	IsCustRevisit: false as boolean,
	PovId: null as number | null,
	PnvId: null as number | null,
	EditPracIdText: null as string | null,
	ZakaznikIdText: null as string | null,
	ZakaznikSk: null as number | null,
	OzakazkaPzn: null as null | ZAKAZKA_TYP,
	Operations: null as number | null,
	OzakazkaId: null as number | null,
	OzakazkId: null as number | null,
	DrMatSzb: null as number | null,
	LakdruhId: null as number | null,
	OzakazkaNr: null as number | null,
	SlevaMat: null as number | null,
	SlevaPujcpa: null as number | null,
	ProvozovnaId: null as number | null,
	EditPracId: null as number | null,
	StkPrp: null as boolean | null,
	ZakazsplitPrp: null as boolean | null,
	SmluvpartnerPzn: null as number | null,
	DrMatPc: null as number | null,
	SlevaSlz: null as number | null,
	SlevaEmise: null as number | null,
	SlevaCv: null as number | null,
	SlevaLak: null as number | null,
	SmVariaList: [], // TODO: asi smazat nevidim to v DTO overit
	ZakazplanDat: null as string | null,
	ZakazkaDat: null as string | null,
	VozidloId: null as number | null,
	VozidloIdText: null as string | null,
	VozidloText: null as string | null,
	ZakaznikId: null as number | null,
	PracovnikId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupPracOsobniCis: null as string | null,
	VstupPracId: null as number | null,
	Text: null as string | null,
	ZakazkaDruh: null as string | null,
	ZakaznikkonIdText: null as string | null,
	ZakaznikkonId: null as number | null,
	PracovnikIdText: null as string | null,
	VozidlokonIdText: null as string | null,
	VozidlokonId: null as number | null,
	VozidloIdVin: null as string | null,
	UrovenPole: 0 as number | null,
	CanZprac: true as boolean | null,
	CanEditVozidlo: true as boolean | null,
	CanEditZakaznik: true as boolean | null,
	IsCustomerFirstVisit: null as boolean | null,
	Remarks: null as string | null,
	FirstVisitVisible: false as boolean | null,
	EnableRegionFlag: null as boolean | null,
	EnableRegionFlagForWatchlisted: null as boolean | null,
	ServicePackageTxt: null as string | null,
	CategoryName: null as string | null,
	ServiceOrderType: null as string | null,
	PackageType: null as string | null,
	ServicePackageId: null as number | null,
	ZakazkaId: 0 as number,
	DisabledFeedback: true as boolean | true,
	CustomerFeedbackRating: null as number | null,
	IsSafetyRemarks: false as boolean | null,
	VrPrijmeni: null as string | null,
	VrTelNr: null as string | null,
	VrJmeno: null as string | null,
	VrEMailAdresa: null as string | null,
	areAllDisabled: false as boolean | null,
	PozadPredaniDat: null as string | null,
	IsPotentialLead: false as boolean | null,
	LeadRemarks: null as string | null,
	LeadType: null as string | null,
	IsPotentialLeadVisible: false as boolean | null,
	WatchlistFlag: false as boolean | null,
	NotificationMessage: null as string | null,
	OrderSubtypeId: null as number | null,
	IsMandatoryCampaign: null as boolean | null,
	IsOptionalCampaign: null as boolean | null,
	viewDialogCampaign: null as boolean | null,
	optinalCampaignCount: 0 as number | null,
	IsWatchlistedRejected: false as boolean | null,
	CustDocReminder: false as boolean | null,
	CancellationRemarks: null as string | null,
	OthersType: null as number | null,
	PracovniPozice: [] as any[] | null,
	NahradniDily: [] as any[] | null,
	ServiceJobs: [] as any[] | null,
	OrderReportTypes: [] as any[] | null,
	TotDiscPercentParts: 0 as number | null,
	VyrobekvozOzn: null as string | null,
	Mrp: null as number | null,
	MrpId: null as number | null,
	TotDiscPercentLabor: 0 as number | null,
	VozidloVin: null as string | null,
	isViewCampaignBtnClicked: false as boolean,
	Stock: null as number | null,
	IsInternalCustomer: null as boolean | null,
	VehicleBrand: [] as string[] | null,
	MeasuringUnit: null as number | null,
	DefaultWarehouseId: null as number | null,
	ReportID: null as string | null,
    PlannedOrderServiceJobs: [] as any[] | null,
    isPrimaryCustomerDelar: false as boolean,
	IsElsaProAutosync: false as boolean,
	IsOrderPresent: false as boolean,
	ElsaProOrderId: null as string | null,
	ContactTypeId: null as number | null,
	CustomerContactDetails: [] as CustomerContactDto[] | null,
	SelectedCustomerContactDetail: null as CustomerContactDto | null,
};
export interface CustomerContactDto {
	Id: number;
	SfContactId: number | null;
	Name: string | null;
	Email: string | null;
	Phone: string | null;
	Mobile: string | null;
	Zip: string | null;
	City: string | null;
	Address: string | null;
	Relationship: string | null;
	ContactTypeId: number;
	ContactTypeText: string | null;
	CustomerId: number;
	LastModifiedTimeAtSF: Date | string;
	CreatedAt: Date | string;
	UpdatedAt: Date | string;
}

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames: DEPENDENT_TABLES,
	depTableSettings: {
		[ND]: {
			isEditable: true,
			columns: {
				STOCK: { isEditable: true, required: true, type: 'dropdown', minWidth: '300px' },
				VYROBEKND_OZN: { isEditable: true, required: true, type: 'dropdown', minWidth: '300px' },
				ND_NR: { isEditable: true, required: true, type: 'dropdown', minWidth: '350px' },
				LOCAL_RRP_ID: { isEditable: true, required: true, type: 'dropdown', minWidth: '150px' },
				UNIT_PRICE_: { isEditable: false, required: false, type: 'text', minWidth: '150px' },
				RRP_UNIT_PRICE: { isEditable: true, required: false, type: 'decimal', minWidth: '200px' },
				TEXT: { isEditable: true, required: true, type: 'text', minWidth: '200px' },
				PC: { isEditable: true, required: true, type: 'decimal', minWidth: '200px' },
				MNOZSTVI_SJ: { isEditable: true, required: true, type: 'decimal', minWidth: '200px' },
				MNOZSTVI_SJ_KOR: { isEditable: true, required: false, type: 'integer', minWidth: '200px' },
				SERVICE_JOB_ID: { isEditable: true, required: false, type: 'dropdown', minWidth: '200px' },
				SLEVA: { isEditable: true, required: false, type: 'decimal', minWidth: '200px' },
				NDP: { isEditable: false, required: true, type: 'text', minWidth: '150px' },
				PART_QUANTITY: { isEditable: false, required:false, type: 'text', minWidth: '150px' },
				BASE_UNIT_OF_MEASUREMENT: { isEditable: false, required: false, type: 'text', minWidth: '200px' },
				CONVERTED_UNIT_OF_MEASUREMENT: { isEditable: false, required: false, type: 'text', minWidth: '200px' },
				CONVERTED_QUANTITY: { isEditable: false, required: false, type: 'decimal', minWidth: '200px' },
				TECHNICIAN: { isEditable: true, required: false, type: 'dropdown', minWidth: '300px' },
			},
			filter(state) { return { OzakazkaId: state.edit.OzakazkaId }; },
		},
		[PRACOVNI_POZICE]: {
			isEditable: true,
			columns: {				
				LO_NUMBER: { isEditable: true, required: true, type: 'dropdown', minWidth: '200px' },				
				PP_NR: { isEditable: true },
				CAS_JDN_POC: { isEditable: true, required: true, type: 'integer', minWidth: '150PX' },
				PRACOVNIK_ID: { isEditable: true, required: true, type: 'dropdown', minWidth: '200px' },
				LO_DESCRIPTION: { isEditable: true, required: true, type: 'text', minWidth: '200px' },
				SERVICE_JOB_ID: { isEditable: true, required: false, type: 'dropdown', minWidth: '200px' },
				DISCOUNT_PERCENT: { isEditable: true, required: false, type: 'decimal', minWidth: '150px' },
				PC_BEZ_DPH_NAD: { isEditable: false, required: false, type: 'decimal', minWidth: '150px' },
				STREDNAKL_OZN: { isEditable: true, required: true, type: 'dropdown', minWidth: '150px' },				
			},
			filter(state) { return { OzakazkaId: state.edit.OzakazkaId }; },
		},
		[ZAKAZKA_ND_PENDING]: { filter(state) { return { ZakazkalistId: state.edit.OzakazkaId, PendingItem: 2, ZakazkaId: 0 }; } },
		[ZAKAZKA_PP_PENDING]: { filter(state) { return { ZakazkalistId: state.edit.OzakazkaId, IsPendingItem: 2, ZakazkaId: 0 }; } },
		[MERGE_ZAKAZNIK]: {
			filter(state) {
				return {
					...(state.edit.ZakaznikkonId && { ZakaznikkonId: state.edit.ZakaznikkonId }),
				};
			},
		},
		[SERVICE_PKG_PARTS]: {
			loadByEntityId: true,
			filter(state) {
				return { ServicePackageId: state.edit.ServicePackageId ? state.edit.ServicePackageId : 0 };
			},
		},
		[SERVICE_PKG_LABOR]: {
			loadByEntityId: true,
			filter(state) {
				return { ServicePackageId: state.edit.ServicePackageId ? state.edit.ServicePackageId : 0 };
			},
		},
		[MERGE_VOZIDLO]: {
			filter(state) {
				return {
					...(state.edit.VozidlokonId && { VozidlokonId: state.edit.VozidlokonId }),
				};
			},
		},
		[ZAKAZKY_LIST]: {
			filter(state) {
				return {
					OtevrenePrp: true,
					PripravaPrp: true,
					Spz: state.edit.VozidloIdSpz,
				};
			},
		},
		[POLOZKY]: {
			filter(state) {
				return {
					VozidloId: state.edit.VozidloId,
				};
			},
		},
		[ZAKAZKY_ESHOP_LIST]: {
			filter(state) {
				return {
					...(state.edit.ZakaznikId && { ZakaznikId: state.edit.ZakaznikId }),
					OzakazkaId: state.edit.OzakazkaId,
				};
			},
		},
		[CAMPAIGN_DETAILS]: {
			loadByEntityId: true,
			filter(state) {
				return { VozidloVin: state.edit.VozidloIdVin, ZakazkaId: 0, PlannedOrderId: state.edit.OzakazkaId };
			},
		},
		[PLANNED_ORDER_SERVICE_JOB]: {
			isEditable: true,
			columns: {
				SERVICE_JOB_ID: { isEditable: true, required: true, type: 'text', minWidth: '250px' },
				SERVICE_JOB_DESCRIPTION: { isEditable: false, required: false, type: 'text', minWidth: '250px' },
				SERVICE_JOB_COMMENTS: { isEditable: true, required: false, type: 'text', minWidth: '250px' },
			},
			filter(state) { return { OzakazkaId: state.edit.OzakazkaId }; },
		},
	},
	localState: {
		fromSuccesMerge: false as boolean | null,
		LabourValue: '' as string,
		viewDialogCampaign: false as boolean | null,
		CampaignTable: [] as any[],
		CampaignData: [] as any[],
		SelectedCampaign: null as number | null,
		mandatoryCampaignCount: 0 as number,
		isQuantityZero: null as boolean | null,
	},
	extraActions: {
		[types.actions.GET_CAMPAIGN_DETAILS]: async ({ commit, state } : VuexProps) => {
			const result = await zakazkaApiProvider.getCampaignDetails(state.edit.VozidloIdVin || '', 0, state.edit.OzakazkaId || null);
			commit(types.mutations.GET_CUSTOMER_CAMPAIGN_DETAILS, result);
		},
		[actions.SERVICE_JOB_CHANGE]: async ({ commit, state, dispatch }) => {
			const selectedJobs = state.edit.ServiceJobs!;
			state.dropdownList.ServiceJobForItems = state.dropdownList.ServiceJobs.filter(x => selectedJobs.includes(x.Value));
		},
		[actions.CREATE_ZAKAZKA]: ({ commit, state, dispatch }, stav) => updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.createZakazka(state.edit.OzakazkaId, stav, -1, '0'),
		),
		[actions.ZAKAZNICKA_SKUPINA_CHANGE]: ({ commit, state, dispatch }) => updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.zakaznickaSkupinaChange(state.edit),
		),
		[actions.FAKTURACNI_PROFIL_CHANGE]: ({ commit, state, dispatch }) => updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.fakturacniProfilChange(state.edit),
		),
		[actions.ZAKAZNIK_CHANGE]: ({ commit, state, dispatch }) => updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.zakaznikChange(state.edit),
		),
		[actions.VOZIDLO_CHANGE]: async ({ commit, state, dispatch }) => {
			const zakazka:any = await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.vozidloChange(state.edit),
			);
			if (state.edit.EnableRegionFlag) {
				const customerFirstVisitStatus = await updateEditAction(
					state,
					commit,
					dispatch,
					zakazkaApiProvider.customerFirstVisitCheck(state.edit.VozidloId ? state.edit.VozidloId : 0),
				);
				if (customerFirstVisitStatus.data!) {
					commit(editMutations.OZAKAZKA_ZAKAZNIK_FIRST_VISIT, customerFirstVisitStatus);
				}
			}
			if (zakazka.data.VozidloIdVin) {
				if (state.edit.CancelOrRescheduleStatus !== ORDER_STATUS.CANCEL && (state.edit.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || state.edit.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA)) {
					dispatch(types.actions.GET_CAMPAIGN_DETAILS);
				}
			}
		},
	},
	extraGetters: {},
	extraMutations: {
		[types.mutations.GET_CUSTOMER_CAMPAIGN_DETAILS](state, { data }: Data<string | null>) {
			if (data && data.length && !state.localState.viewDialogCampaign) {
				state.localState.CampaignData = data;
				state.localState.viewDialogCampaign = true;
			}
		},
		[editMutations.OZAKAZKA_VSTUP_PRAC_SELECT_MAPPER](state, { data }) {
			state.edit.VstupPracId = data.value;
			state.edit.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.VstupPracOsobniCis = data.osobniCis;
		},
		[editMutations.OZAKAZKA_LAK_DRUH_SELECT_MAPPER](state, { data }) {
			state.edit.LakdruhId = data.value;
			state.edit.LakdruhIdText = data.text;
		},
		async [editMutations.OZAKAZKA_VOZIDLO_SELECT_MAPPER](state, { data }) {
			if (state.edit.VozidloId !== data.value) {
				state.edit.VozidloId = data.value;
				state.edit.VozidloText = data.text;
				state.edit.VozidloIdText = data.karoserieNr;
				state.edit.VozidloIdVin = data.karoserieNr;
				state.edit.VozidloIdSpz = data.spz;
			}
		},
		[editMutations.VOZIDLO_RIDIC_MAPPER](state, { data }) {
			state.edit.VrPrijmeni = data.prijmeni;
			state.edit.VrTelNr = data.telefon;
			state.edit.VrJmeno = data.jmeno;
			state.edit.VrEMailAdresa = data.email;
			state.edit.PozadPredaniDat = data.PozadPredaniDat;
		},
		[types.mutations.COMPUTE_ROWS_HASH](state) {
			state.dependentTables.Polozky.hash = hash(state.dependentTables.Polozky.rows);
		},
		[editMutations.OZAKAZKA_ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			if (state.edit.ZakaznikId !== data.value) {
				state.edit.ZakaznikId = data.value;
				state.edit.ZakaznikIdText = data.text;
			}
		},
		[editMutations.OZAKAZKA_ZAKAZNIK_FIRST_VISIT](state, { data }) {
			if (data.IsCustomerFirstVisit) {
				state.edit.FirstVisitVisible = true;
			} else {
				state.edit.FirstVisitVisible = false;
			}
		},
		[editMutations.SAVE_OZAKAZKA_AFTER_MERGE](state, data) {
			state.localState.fromSuccesMerge = true;
			if (data.ZakaznikId) {
				state.edit.ZakaznikId = data.ZakaznikId;
				state.edit.ZakaznikIdText = data.Jmeno ? `${data.Jmeno} ${data.Text}` : data.Text;
				state.edit.ZakaznikkonId = null;
				state.edit.ZakaznikkonIdText = null;
			} else if (data.VozidloId) {
				state.edit.VozidloId = data.VozidloId;
				state.edit.VozidloIdText = data.KaroserieNr;
				state.edit.VozidloIdSpz = data.Spz;
				state.edit.VozidlokonId = null;
				state.edit.VozidlokonIdText = null;
			}
		},

		[editMutations.SERVICE_PACKAGE](state, { data }) {
			state.edit.ServicePackageId = data.value;
			state.edit.ServicePackageTxt = data.text;
			state.edit.CategoryName = data.CategoryName;
			state.edit.ServiceOrderType = data.ServiceOrderType;
			state.edit.PackageType = data.PackageType;
		},
	},
	props: {
		filter: {
			ZakazkaId: null as number | null,
			NdNr: null as string | null,
			VyrobekndOzn: null as string | null,
			SkladOzn: null as number | null,
		},
		mode: null,
	},
});
